import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { ActivatedRoute, Router } from '@angular/router';
import { finalize } from 'rxjs/operators';
import { ApiservicesService } from '../../../../Services/Apis/apiservices.service';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { DynamicPageCreationComponent } from '../../../../components/webpagecreation/dynamic-page-creation/dynamic-page-creation.component';
import { PageNameService } from '../../../../inputfileds/form_services/websitemanagementService02/webSitesName/pageName/page-name.service';
import { Observable } from 'rxjs';
import { PermissionService } from '../../../../components/Authentication/services/permission.service';
import { TranslateDirective } from '../../../../components/Utilites/Directives/translate.directive';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

export interface PageComponent {
  id: string;
  type: string;
  title: string;
  image_url: string;
}

export interface Page {
  id: string;
  name: string;
  description: string;
}

@Component({
  selector: 'app-page-name-list',
  standalone: true,
  templateUrl: './page-name-list.component.html',
  styleUrls: ['./page-name-list.component.scss'],
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatListModule,
    MatCardModule,
    MatMenuModule,
    MatDialogModule,
    TranslateDirective,
    MatProgressSpinnerModule,
  ],
  providers: [ApiservicesService],
})
export class PageNameListComponent implements OnInit {
  pages: Page[] = [];
  noData = false;
  websiteNameId: any;
  websiteURL: any;

  loading = false;
  errorMsg = '';
  actiondata: any;

  constructor(
    private dialog: MatDialog,
    private _router: Router,
    private _route: ActivatedRoute,
    private apiServices: ApiservicesService,
    private permissionService: PermissionService,
    private pagesNameQuestion: PageNameService,
  ) {}

  ngOnInit(): void {
    this.actiondata = this.permissionService.getactiondata();
    //  if (
    //   this.route.snapshot?.queryParams['dataId'] &&
    //   !isNaN(this.route.snapshot?.queryParams['dataId'])
    // ) {
    //   this.dataId = this.route.snapshot?.queryParams['dataId'];
    //   this.getemployeesdetails(this.dataId);
    // }
    this.websiteNameId = this._route.snapshot?.queryParams['websiteId'];
    if (this.websiteNameId) {
      this.getPagesByWebsiteId();
    }
    this.websiteURL = this._route.snapshot?.queryParams['websiteURL'];
  }

  getPagesByWebsiteId(): void {
    this.loading = true;
    this.errorMsg = '';

    this.apiServices
      .getWebsitePages(this.websiteNameId)
      .pipe(finalize(() => (this.loading = false)))
      .subscribe({
        next: (res) => {
          this.pages = res?.rows;
          this.noData = this.pages.length === 0;
        },
        error: (err) => {
          console.error('Error loading pages:', err);
          this.pages = [];
          this.noData = true;
          this.errorMsg = 'Failed to load pages. Please try again.';
        },
      });
  }

  private openDynamicDialog(config: {
    pageTitle: string;
    questions$: Observable<any>;
    submitButtonText: string;
    onSubmit: (formData: any) => void;
    initialData?: any;
    TabButton?: boolean;
  }) {
    const dialogRef = this.dialog.open(DynamicPageCreationComponent, {
      width: '600px',
      data: {
        pageTitle: config.pageTitle,
        questions$: config.questions$,
        submitButtonText: config.submitButtonText,
        initialData: config.initialData,
        TabButton: false,
      },
    });

    dialogRef.afterClosed().subscribe((formData) => {
      if (formData) {
        config.onSubmit(formData);
      }
    });

    dialogRef.componentInstance.cancel.subscribe(() => {
      dialogRef.close();
    });
  }

  openAddPageDialog() {
    this.openDynamicDialog({
      pageTitle: 'Add Page',
      questions$: this.pagesNameQuestion.getpagesNameform(),
      submitButtonText: 'Add Page',
      TabButton: true,
      onSubmit: (formData) => {
        formData.website_id = this.websiteNameId;
        formData.name = formData.name.toLowerCase();
        this.loading = true;
        this.apiServices
          .addPageToWebsite(this.websiteNameId, formData)
          .pipe(finalize(() => (this.loading = false)))
          .subscribe({
            next: (res: any) => {
              this.pages.push(res);
              this.getPagesByWebsiteId();
            },
            error: (err) => {
              console.error('6. API Error:', err);
              console.error('7. Error details:', err.message, err.status);
            },
          });
      },
    });
  }

  openEditPageNameDialog(PageData: any): void {
    this.openDynamicDialog({
      pageTitle: 'Update Website Name',
      questions$: this.pagesNameQuestion.getpagesNameform(),
      submitButtonText: 'Update Website Name',
      initialData: PageData,
      onSubmit: (formData) => {
        if (!formData.id) {
          console.error('No ID provided for update');
          return;
        }
        this.loading = true;
        formData.name = formData.name.toLowerCase();
        this.apiServices
          .updateWebsitePageName(formData.id, formData)
          .pipe(finalize(() => (this.loading = false)))
          .subscribe((response: any) => {
            const index = this.pages.findIndex(
              (w: any) => w.id === response.id,
            );
            if (index !== -1) {
              this.pages[index] = response;
            }
            this.getPagesByWebsiteId();
          });
      },
    });
  }

  viewPageComponents(pageID: string): void {
    this._router.navigate([`/websites/WebcomponentList`], {
      queryParams: {
        websiteId: this.websiteNameId,
        pageId: pageID,
        websiteURL: this.websiteURL,
      },
    });
  }

  deletePage(pageId: string): void {
    this.loading = true;
    this.apiServices
      .deleteWebsitePages(pageId)
      .pipe(finalize(() => (this.loading = false)))
      .subscribe({
        next: () => {
          this.pages = this.pages.filter((page) => page.id !== pageId);
          this.getPagesByWebsiteId();
        },
        error: (err) => {
          console.error('Error deleting page:', err);
        },
      });
  }

  goBack(): void {
    this._router.navigate(['/websites']);
  }
}
